<template>
  <div class="main mx-5">
    <!-- <div class='main-spinner' :class="{active: loading}">
      <div class="middle">
        <div class="middle-inner">
          <letter-cube :size="'200px'"></letter-cube>
        </div>
      </div>
    </div> -->
    <div v-loading="loading">
      <div class="row grid grid-cols-1 md:grid-cols-3 gap-1 pb-3">
        <div>
          <div :class="errorClassObject('my_funds')" class="grid grid-cols-1 md:grid-cols-3 gap-1">
            <div class="col-span-3">
              <div v-if="errorObject('my_funds')" class="text-red-500 font-bold text-right">自分の投資用資金を円単位で入力ください。</div>
            </div>
            <div class="col-span-1 md:col-span-1">
              <label for="inputMyFunds" class="control-label text-lg text-gray-700 font-bold">自分の投資用資金</label>
            </div>
            <div class="col-span-1 md:col-span-2">
              <input v-model="my_funds" type="number" class="h-10 rounded form-control text-right bg-white rounded w-full border border-gray-300" id="inputMyFunds" placeholder="1万〜100億" min="10000" max="10000000000">
              <div class="help-block text-right text-lg text-gray-400">{{my_funds_conv}}</div>
            </div>
            <div class="col-span-3 pb-3">
              <div class="help-block text-right text-lg text-gray-400">投資用資金の1%(<strong>A</strong>) = {{moneyDelimiter(my_funds_in_conv)}}</div>
            </div>
          </div>
          <div :class="errorClassObject('loss_cut_range')" class="grid grid-cols-3 gap-1">
            <div class="col-span-1">
              <label for="inputLossCutRange" class="control-label text-lg text-gray-700 font-bold">ロスカットの幅<br>ATRの●倍</label>
            </div>
            <div class="col-span-2">
              <input v-model="loss_cut_range" type="number" class="h-10 rounded form-control text-right bg-white rounded w-full border border-gray-300" id="inputLossCutRange" placeholder="1.0〜10.0" step="0.1" min="1" max="10">
            </div>
          </div>
        </div>
        <div class="justify-self-center">
          <div class="row">
            <div class="col-md-12 text-center text-xl md:text-3xl text-gray-700">
              <h4 v-bind:class="{ 'text-danger': isDanger }">現在の合計リスク <span>{{valueRounding(now_total_risk,1)}}</span> %</h4>
            </div>
          </div>
        </div>
        <div class="justify-self-center">
          <br>
          <div class="col-md-12">
            <div class="text-right">
              <el-button class="w-20 h-10" v-on:click="saveData" :type="(saveLoading) ? 'warning' : 'success'" plain>
                <span v-show="saveLoading"><i class="el-icon-loading"></i>&nbsp;</span><span class="text-lg">保存</span>
              </el-button> 
              <el-button class="w-20 h-10 text-lg" v-on:click="addRow()" type="danger" plain>行追加</el-button>
            </div>
          </div>
        </div>
      </div>

      <el-table :data="rows" max-height="750" stripe border size="mini">
        <el-table-column label="コード" header-align="center" min-width="180" width="180">
          <template v-slot="rows">
            <div :class="errorClassObjectRow(rows.$index)">
              <el-select size="large" v-model.trim="rows.row.brand_code" v-on:change="brandCodeInput(rows.row.brand_code, rows.$index)" filterable placeholder="入力または選択">
                <el-option
                  v-for="(item, key) in m_fx_brands"
                  :key="key"
                  :label="key"
                  :value="key">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="銘柄" header-align="center"  min-width="200">
          <template v-slot="rows">
            <div class="text-lg">
              <span v-show="rows.row.brandLoading"><i class="el-icon-loading"></i>銘柄取得中...</span>
              {{ rows.row.brand_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="前日終値" header-align="center" min-width="150">
          <template v-slot="rows">
            <div class="text-right no-wrap text-lg">
              {{moneyDelimiter(rows.row.lastday_closing_price)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="B" header-align="center">
          <el-table-column label="ATR" header-align="center" min-width="90">
            <template v-slot="rows">
              <div class="text-right no-wrap text-lg">
                {{moneyDelimiter(rows.row.atr)}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="A÷(B×為替)" header-align="center">
          <el-table-column :label="'ユニット\nサイズ'" label-class-name="el-whitespace" header-align="center" min-width="130">
            <template v-slot="rows">
              <div class="text-right no-wrap text-lg">
                {{ moneyDelimiter(orgRound(my_funds_in / ( rows.row.atr * rows.row.kawase ), 1)) }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="C" header-align="center">
          <el-table-column label="保有通貨数" header-align="center" min-width="150">
            <template v-slot="rows">
              <div class="text-right no-wrap text-lg">
                <input v-model='rows.row.holding_shares' type="number" name="holding_shares" class="h-10 rounded text-right form-control border border-gray-300 w-11/12">
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="C÷(A÷(B×為替))" header-align="center">
          <el-table-column :label="'1日の\nリスク (%)'" label-class-name="el-whitespace" header-align="center" min-width="170">
            <template v-slot="rows">
              <div class="text-right no-wrap text-lg">
                {{ valueRounding(rows.row.holding_shares / ( my_funds_in / ( rows.row.atr * rows.row.kawase ) ),1 ) }}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column :label="'エントリー\n価格'" label-class-name="el-whitespace" header-align="center" min-width="150">
          <template v-slot="rows">
            <div class="text-right no-wrap text-lg">
              <input v-model='rows.row.purchase_stock_price' type="number" name="purchase_stock_price" class="h-10 rounded text-right form-control border border-gray-300 w-11/12">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="売買" header-align="center"  min-width="110" width="110">
          <template v-slot="rows">
            <el-select size="large" v-model="rows.row.trading" placeholder="買/売">
              <el-option
                v-for="item in rows.row.trading_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="'ロスカット\nライン'" label-class-name="el-whitespace" header-align="center" min-width="130">
          <template v-slot="rows">
            <div class="text-right no-wrap text-lg">
              {{moneyDelimiter(loss_cut_line(rows.$index))}}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="" width="120">
          <template v-slot="row">
            <div class="text-center">
              <el-button class="w-20 h-10 text-lg" v-on:click="btn_clear(row.$index)" type="warning" plain>Clear</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { axios } from '@/plugins/axios'
// import {LetterCube} from 'vue-loading-spinner'

//初期行数
let loop = 20

export default {
  name: 'funds-management-fx',
  // filters: {
  //   // 四捨五入、初期表示調整
  //   valueRounding(value, num) {
  //     if (!num) {
  //       num = 0
  //     }
  //     let result = 0
  //     isFinite(value) ? (result = value.toFixed(num)) : (result = 0)
  //     return result
  //   },
  //   // 数値にカンマを付与
  //   moneyDelimiter(value) {
  //     // return value.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  //     return value.toLocaleString(undefined, { maximumFractionDigits: 5 }) // 勝手に丸められるので小数点第5位まで考慮、IE非対応
  //   }
  // },
  data() {
    // 表側の定義
    let rows = []
    for (let i = 0; i < loop; i++) {
      let row = {
        brand_code: '', // コード
        brandLoading: false, // 銘柄毎のローディング
        brand_name: '', // 銘柄
        atr: '', // ATR
        holding_shares: '', // 保有通貨数
        purchase_stock_price: '', // エントリー価格
        trading_options: [ {
          value: 1,
          label: '買い'
        }, {
          value: -1,
          label: '売り'
        } ],
        trading: '', // 売買
        lastday_closing_price: 0, // 前日終値
        kawase: 0, // 為替
        row_isValidate: true
      }
      rows.push(row)
    }
    return {
      my_funds: '', // 自分の投資用資金
      loss_cut_range: 2.0, // ロスカットの幅
      balance: 0, // 残高
      margin_trading_balance: 0, // 信用取引残高
      rows: rows,
      validates: {
        my_funds_min: 10000, // 検証用 自分の投資用資金最小
        my_funds_max: 10000000000, // 検証用 自分の投資用資金最大
        loss_cut_range_min: 1, // 検証用 ロスカット幅最小
        loss_cut_range_max: 10, // 検証用 ロスカット幅最大
        brand_code_length: 7, // 検証用 コード長
      },
      m_fx_brands: '', // 小数点マスタ（みたいなもん）ちょっと加工してある。
      isDanger: false, // テキスト色変え
      loading: true,
      saveLoading: false,
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    // 入力金額が見辛いので変換
    my_funds_conv() {
      let str = ''
      let result
      result = this.my_funds
      if (!result || result < 1) {
        return ''
      }
      if (result >= 100000000) {
        result = result / 100000000
        str += '億円'
      } else if (result >= 10000) {
        result = result / 10000
        str += '万円'
      } else {
        str += '円'
      }
      return result.toLocaleString() + str
    },
    // 現在の合計リスク
    now_total_risk() {
      let result = 0
      this.rows.forEach(row => {
        if (!row.holding_shares || !this.my_funds_in || !row.atr || !row.kawase) {
          return
        }
        result += row.holding_shares / (this.my_funds_in / (row.atr * row.kawase))
      })
      if (!result) {
        result = 0
      }
      // テキスト色変え
      if (result >= 10) {
        this.onIsDanger()
      } else {
        this.offIsDanger()
      }

      return result
    },
    // 投資用資金の1%
    my_funds_in() {
      if (this.validation['my_funds'] === false) {
        return 0
      }
      let result = this.orgRound(this.my_funds / 100, 1)

      return result
    },
    my_funds_in_conv() {
      let result = this.my_funds_in
      if (!result) {
        return 0 + '円'
      }

      let str = ''

      if (result >= 100000000) {
        result = result / 100000000
        str += '億円'
      } else if (result >= 10000) {
        result = result / 10000
        str += '万円'
      } else {
        str += '円'
      }
      return result.toLocaleString() + str
    },
    // バリデーション（表側以外）
    validation() {
      const my_funds = this.my_funds
      const loss_cut_range = this.loss_cut_range
      return {
        my_funds:
          !!my_funds &&
          my_funds >= this.validates.my_funds_min &&
          my_funds <= this.validates.my_funds_max,
        loss_cut_range:
          !!loss_cut_range &&
          loss_cut_range >= this.validates.loss_cut_range_min &&
          loss_cut_range <= this.validates.loss_cut_range_max
      }
    },
    isValid() {
      const validation = this.validation
      return Object.keys(validation).every(key => {
        return validation[key]
      })
    }
  },
  methods: {
    onIsDanger() {
      this.isDanger = true
    },
    offIsDanger() {
      this.isDanger = false
    },
    // 四捨五入、初期表示調整
    valueRounding(value, num) {
      if (!num) {
        num = 0
      }
      let result = 0
      isFinite(value) ? (result = value.toFixed(num)) : (result = 0)
      return result
    },
    // 数値にカンマを付与
    moneyDelimiter(value) {
      // return value.toString().replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      return value.toLocaleString(undefined, { maximumFractionDigits: 5 }) // 勝手に丸められるので小数点第5位まで考慮、IE非対応
    },
    addRow() {
      // let virtual = this
      this.rows.push({
        brand_code: '', // コード
        brandLoading: false, // 銘柄毎のローディング
        brand_name: '', // 銘柄
        atr: '', // ATR
        holding_shares: '', // 保有通貨数
        purchase_stock_price: '', // エントリー価格
        trading_options: [ {
          value: 1,
          label: '買い'
        }, {
          value: -1,
          label: '売り'
        } ],
        trading: '', // 売買
        lastday_closing_price: 0, // 前日終値
        kawase: 0, // 為替
        row_isValidate: true
      })
    },
    orgRound(value, base) {
      if (!base) { base = 1 }
      if (!value || !isFinite(value)) { return 0 }
      return Math.round(value * base) / base
    },
    async brandCodeInput(brand_code, index) {
      if (
        !!brand_code &&
        brand_code.length === this.validates.brand_code_length
      ) {
        this.rows[index].row_isValidate = true
        this.rows[index].brandLoading = true // 銘柄毎のローディング

        await axios.post('/funds-management/fetch-stock-fx', {
          brand_code: brand_code
        })
          .then(response => {
            this.rows[index].brand_name = response.data[0].code_name
            this.rows[index].lastday_closing_price = response.data[0].closing_price
            this.rows[index].atr = response.data[0].atr20
            this.rows[index].kawase = response.data[0].kawase
            this.$message.success(
              '銘柄：' +
                response.data[0].code_name +
                '  最新日付：' +
                response.data[0].date
            )
          })
          .catch(err => {
            this.$message.error({
              message: '情報を取得できませんでした。'
            })
          })
        this.rows[index].brandLoading = false // 銘柄毎のローディング
      } else {
        this.rows[index].row_isValidate = false
      }
    },
    loss_cut_line(index) {
      if (this.validation['loss_cut_range'] === false) {
        return 0
      }
      if (
        this.rows[index].purchase_stock_price &&
        this.rows[index].atr &&
        this.loss_cut_range &&
        this.rows[index].trading
      ) {
        const code = this.rows[index].brand_code
        const decimal = this.m_fx_brands[code].decimal * 10 // tr桁数 = マスタの桁数、ATRと同じにするのでもう1桁追加
        return this.orgRound(
          this.rows[index].purchase_stock_price -
            this.rows[index].atr *
              this.loss_cut_range *
              this.rows[index].trading,
          decimal
        )
      } else {
        return 0
      }
    },
    // clear処理
    btn_clear(index) {
      this.rows[index].brand_code = '' // コード
      this.rows[index].brand_name = '' // 銘柄
      this.rows[index].atr = '' // ATR
      this.rows[index].holding_shares = '' // 保有通貨数
      this.rows[index].purchase_stock_price = '' // エントリー価格
      this.rows[index].trading = '' // 売買
      this.rows[index].lastday_closing_price = 0 // 前日終値
      this.rows[index].kawase = 0 // 前日終値
      this.rows[index].row_isValidate = true
    },
    errorObject(key) {
      return this.validation[key] === false
    },
    errorClassObject(key) {
      return {
        'has-error': this.validation[key] === false
      }
    },
    errorClassObjectRow(index) {
      return {
        'has-error': this.rows[index].row_isValidate === false
      }
    },
    async saveData() {
      this.saveLoading = true
      let sdata = {
        my_funds: this.my_funds,
        loss_cut_range: this.loss_cut_range,
        rows: this.rows
      }
      await axios
        .post('/funds-management/save-funds-fx/', sdata)
        .then(res => {
          this.$message.success('情報を登録しました。')
        })
        .catch(error => {
          this.$message.error({
            dangerouslyUseHTMLString: true,
            message:
              '情報を登録できませんでした。<br>' + error.response.data.status
          })
        })
      this.saveLoading = false
    },
    async fetchData() {
      axios
        .get('/funds-management/fetch-mfx-brands')
        .then(res => {
          this.m_fx_brands = res.data
        })
        .catch(error => {
          this.$message.error({
            dangerouslyUseHTMLString: true,
            message: '小数点情報を取得できませんでした。'
          })
        })
      await axios
        .get('/funds-management/read-funds-fx/')
        .then(async res => {
          let needs = res.data.length - loop
          for (let i = 0; i < needs; i++) {
            this.addRow()
          }
          this.my_funds = res.data[0].my_funds //どの行も同じデータ
          this.loss_cut_range = res.data[0].loss_cut_range //どの行も同じデータ

          for (let i = 0; i < res.data.length; i++) {
            this.rows[i].brand_code = res.data[i].code // コード
            this.rows[i].holding_shares = res.data[i].holding_shares // 保有通貨数
            this.rows[i].purchase_stock_price =
              res.data[i].purchase_stock_price // エントリー価格

            this.rows[i].trading = '' // 売買
            if (res.data[i].trading === '1' || res.data[i].trading === '-1') {
              this.rows[i].trading = Number(res.data[i].trading)
            }
            this.rows[i].row_isValidate = true

            if (res.data[i].code) {
              this.brandCodeInput(res.data[i].code, i)
            }
          }
        })
        .catch(error => {
          if (error.response.data.status !== 'nodata') {
            this.$message.error({
              dangerouslyUseHTMLString: true,
              message: '情報を取得できませんでした。<br>' + error.response.data.status
            })
          }
        })
      this.loading = false
    }
  },
  components: {
    // LetterCube,
  }
}
</script>